import { CommonModule, CurrencyPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, input, Output, signal, WritableSignal } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

@Component({
  imports: [
    CommonModule,
    CurrencyPipe,
    MatFormFieldModule,
    MatInputModule
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
   
  selector: 'lib-currency-box',
  templateUrl: './currency-box.component.html',
  styleUrl: './currency-box.component.scss'
})
export class CurrencyBoxComponent {
  public currencyValue = input.required<number | null>();
  public disabled = input<boolean>(false); 
  public isTouched: WritableSignal<boolean> = signal(false);
  public label = input.required<string>();
  public name = input.required<string>();

  @Output() currencyChanged = new EventEmitter<number | null>();

  public numberOnly($event: KeyboardEvent): boolean {
    const charCode = ($event.which) ? $event.which : $event.keyCode;
    return charCode === 46 || charCode <= 31 || (charCode >= 48 && charCode <= 57);
  }

  public updateAmount($event: Event): void {
    const v: string = ($event.srcElement as HTMLInputElement)?.value;
    const money = (v[0] == '$') ? parseFloat(v.replace('$','').replace(',','')) : parseFloat(v);
    this.isTouched.set(true);
    this.currencyChanged.emit(isNaN(money) ? 0.0 : money);
  }
}